import { Log } from '@xylabs/sdk-js'
import axios from 'axios'

import { API_KEY, API_URL } from './api'
import { DebounceResult } from './DebounceResult'

const cache = new Map<string, DebounceResult>()

export const checkSingleEmail = async (email: string, log?: Log): Promise<DebounceResult> => {
  if (!cache.has(email)) {
    const result = await axios.get<DebounceResult>(`${API_URL}?api=${API_KEY}&email=${email}`)
    if (result.data) {
      cache.set(email, result.data)
    }
  }
  //if the call is failing, assume we should accept it (send_transactional)
  const returnValue = cache.get(email) ?? { debounce: { send_transactional: '1' }, success: '0' }
  log?.info('checkSingleEmail', returnValue)
  return returnValue
}
